export function buildTempScopeChangeLogQuery(filters = {}, override = {}) {
  return {
    limit: 200,
    targetUsername: filters.targetUsername || '',
    templateId: filters.templateId || '',
    startDate: filters.startDate || '',
    endDate: filters.endDate || '',
    ...override,
  };
}

export function normalizeTempScopeChangeLogItems(items) {
  return Array.isArray(items) ? items : [];
}
